import React, { useContext, useState, useEffect, useRef } from "react"
import ReactDatePicker from "react-datepicker"
import { Icon } from "source/shared/components"
import { WebBootContext } from "source/publishing/WebBoot"
import PropTypes from "prop-types"
import moment from "moment-timezone"
import { useCurrentOrganizationTimeZone } from "source/calendar/hooks/useCurrentOrganizationTimeZone"

export const DatePicker = ({
  value,
  onChange,
  showOnLoad = false,
  errorClass,
  maxCap = 20,
  minCap = 120,
  ...rest
}) => {
  const {
    currentOrganization: {
      attributes: { datetime_fmt_configuration },
    },
  } = useContext(WebBootContext)
  const inputRef = useRef(null)
  const timeZone = useCurrentOrganizationTimeZone()
  const [selectedDate, setSelectedDate] = useState(
    value ? moment.tz(value, timeZone).toDate() : null,
  )
  const currentYear = new Date().getFullYear()
  const minDate = new Date(currentYear - minCap, 0, 1)
  const maxDate = new Date(currentYear + maxCap, 11, 31)

  useEffect(() => {
    if (showOnLoad && inputRef.current) {
      inputRef.current.setFocus()
    }
  }, [showOnLoad])

  const handleChange = (date) => {
    setSelectedDate(date)
    if (onChange) {
      const formattedDate = date ? date.toISOString().split("T")[0] : ""
      const fakeEvent = { target: { value: formattedDate } }
      onChange(fakeEvent)
    }
  }

  return (
    <div className={`date-field ${errorClass || ""}`}>
      <span className="date-field__icon ml-1 mt-1">
        <Icon symbol="general#calendar" title="Date" />
      </span>
      <ReactDatePicker
        ref={inputRef}
        selected={selectedDate}
        onChange={handleChange}
        dateFormat={
          datetime_fmt_configuration.dateFirst ? "d/MM/yyyy" : "M/d/yyyy"
        }
        minDate={minDate}
        maxDate={maxDate}
        showYearDropdown
        showMonthDropdown
        showPopperArrow={false}
        dropdownMode="select"
        wrapperClassName="w-100%"
        {...rest}
      />
    </div>
  )
}

DatePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onChange: PropTypes.func,
  showOnLoad: PropTypes.bool,
  errorClass: PropTypes.string,
  minCap: PropTypes.number,
  maxCap: PropTypes.number,
}
